import { createReducer, on } from '@ngrx/store';
import { Request } from './request.model';
import * as requestActions from './request.actions';

export interface RequestState {
  requestList: any[];
  currentRequest: any | null;
  loggedInUser: any | null;
  cognitoToken: string | null;
}

export const initialState: RequestState = {
  requestList: [],
  currentRequest: null,
  loggedInUser : null,
  cognitoToken : null
};

export const requestReducer = createReducer(
  initialState,
  on(requestActions.addRequestList, (state, { requests }) => ({ ...state, requestList: requests })),
  on(requestActions.setCurrentRequest, (state, { request }) => ({ ...state, currentRequest: request })),
  on(requestActions.setLoggedInUser, (state, { request }) => ({ ...state, loggedInUser: request })),
  on(requestActions.setCognitoToken, (state, { cognitoToken }) => ({ ...state, cognitoToken: cognitoToken }))
);
